import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import IssueDetailTable from './issueDetailTable';
import FeatureDetailTable from 'components/Agile/feature/featureDetail/featureDetailTable';
import IssueEdit from '../issueMaintenance/issueEdit';
import { getIssueDisplayData } from 'services/issueService';
import { getFeatureDisplayData } from 'services/featureService';
import {
    onEditIssue,
    onDeleteIssue,
} from 'actions/issue';
import DeleteItemCheck from 'components/deleteItemCheck';
// import { TIGHT_FIT_PARAM } from 'constants/System';

const IssueDetail = () => {
    // const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;
    const dispatch = useDispatch();

    // const allValueStreams = useSelector(state => state.valueStreams.allValueStream);
    const selectedIssue = useSelector(state => state.issues.selectedIssue);
    const selectedOrg = useSelector(state => state.orgs.selectedOrg);
    const [featureDisplayData, setFeatureDisplayData] = useState();
    const [displayData, setDisplayData] = useState();

    useEffect(() => {
        // TODO - do not fetch if no selected issue
        let mounted = true; // fix warning on no-op state when component not mounted https://www.debuggr.io/react-update-unmounted-component/
        const issuePromise = new Promise((resolve) => resolve(getIssueDisplayData(selectedIssue?.id, selectedOrg?.id)));
        const featurePromise = new Promise((resolve) => resolve(getFeatureDisplayData(selectedIssue?.featureId, selectedOrg?.id)));

        const fetchDisplayData = async (ready) => {
            if (ready) {
                await Promise.all([issuePromise, featurePromise]
                    .map((result) => result.catch((error) => error)))
                    .then((values) => {
                        const [
                            issueDisplayData,
                            featureDisplayData] = values;
                        setDisplayData(issueDisplayData);
                        setFeatureDisplayData(featureDisplayData);
                    });
            }
        };
        fetchDisplayData(mounted);
        return () => mounted = false;
    }, [selectedIssue]);

    const mainIcon = () => {
        // TODO pass in type to change the icon on the detail tab
        // if (type && type.toLowerCase() === 'high') {
        //     return 'stream';
        // }
        // if (type && type.toLowerCase() === 'medium') {
        //     return 'compact';
        // }
        // if (type && type.toLowerCase() === 'low') {
        //     return 'module';
        // }
        return 'dashboard';
    };

    if (selectedIssue) {
        // const fields = { ...selectedIssue?.fields };
        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                <div className="row">
                    <div className="col-md-7 col-12">
                        <div className="jr-card jr-card-full-height ml-2 mr-2">
                            <div className="jr-card-header d-flex">
                                <div className="mr-auto">
                                    <h2 className="card-heading">{displayData?.name}</h2>
                                </div>
                                <div>
                                    <DeleteItemCheck
                                        id={selectedIssue?.id}
                                        onConfirm={onDeleteIssue}
                                        alertMessage={<IntlMessages id="issue.deleteIssue" />}
                                    />
                                    <Button size="sm" color="primary" onClick={() => dispatch(onEditIssue(selectedIssue))}>
                                        <i className="zmdi zmdi-edit zmdi-hc-fw" />
                                        <span>{<IntlMessages id="label.edit" />}</span>
                                    </Button>
                                </div>
                            </div>
                            <div className="jr-card-body">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="temp-section mb-4 mb-sm-0 text-center text-sm-left">
                                            <p>
                                                {/* <div className={`btn btn-sm text-uppercase btn-rounded ${style}`}>{order} Order</div> */}
                                                <i className={`detail-icon text-blue-grey zmdi zmdi-view-${mainIcon()} zmdi-hc-fw`} />
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-sm-9 text-center text-sm-left">
                                        <IssueDetailTable displayData={displayData} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <IssueEdit />
                    </div>

                    <div className="col-md-5">
                        <div className="jr-card jr-card-full-height ml-2 mr-2">
                            <div className="mr-auto">
                                <h2 className="card-heading">{<IntlMessages id="label.feature" />}</h2>
                            </div>
                            <div>
                                <FeatureDetailTable displayData={featureDisplayData} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                <div className="row">
                    <div className="col-md-12 col-12">
                        <div className="jr-card jr-card-full-height">
                            <div className="jr-card-header d-flex">
                                <div className="mr-auto">
                                    <h3 className="card-heading">Please select an entry to display details</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default IssueDetail;


// WEBPACK FOOTER //
// ./components/Agile/issue/issueDetail/index.js